import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useCatalogContext } from "../Summary/context/useCatalogContext";
import { FoodsIcon, FoodsIllustrations } from "@foodpilot/foods";
import { AddActionButton } from "./AddActionButton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useActionsContext } from "src/context/Actions/useActionsContext";

type CatalogSideInfoProps = {
    orientation?: "horizontal" | "vertical";
};

export const CatalogSideInfo = (props: CatalogSideInfoProps) => {
    const { orientation = "vertical" } = props;
    const { urls } = useActionsContext();
    const { currentAction } = useCatalogContext();
    const theme = useTheme();
    const { t } = useTranslation();

    if (currentAction === undefined) {
        // Error state: Action doesn't exist
        return null;
    }

    const url =
        currentAction.actionPlanActionId !== undefined ?
            urls.editPlanning(currentAction.actionPlanActionId)
        :   undefined;
    return (
        <Stack
            direction={{ xs: "column", md: orientation === "horizontal" ? "row" : "column" }}
            gap={theme.spacing(3)}
            padding={theme.spacing(3)}
            boxShadow={`0px 2px 8px 0px #2A2B270A`}
            border={`1px solid ${theme.custom.grey[600]}`}
            borderRadius={`12px`}
            bgcolor={"white"}
            alignItems={"center"}
            justifyContent={orientation === "horizontal" ? "space-between" : undefined}
            height={currentAction.imageUrl ? "100%" : undefined}
        >
            <FoodsIllustrations illustration={"selectAction"} />
            <Typography variant="body">
                {currentAction.isEngaged && url !== undefined ?
                    t("action_plan.edit_action_info", "This action is already added")
                :   t(
                        "action_plan.add_action_info",
                        "Add this action to your action plan in order to simulate its impact and get closer to your goal.",
                    )
                }
            </Typography>
            {currentAction.isEngaged && url !== undefined ?
                <Link to={url}>
                    <Button startIcon={<FoodsIcon size={2} icon="edit" />} variant="primary">
                        {t("action_plan.edit_my_action", "Edit my action")}
                    </Button>
                </Link>
            :   <AddActionButton />}
        </Stack>
    );

    // return <StickyActionInfo actionPlanAction={currentActionPlanAction} />;
};
